import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inventario/ingresoInventario';
import IngresoInventario from './IngresoInventario';


const ms2p = (state) => {
  return {
    ...state.proyecto_ingreso_inventario,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(IngresoInventario);
